import {
    FETCH_V2_OS_MOVIMENTADAS_PERIODO_DETALHADOV2, RECEIVE_V2_OS_MOVIMENTADAS_PERIODO_DETALHADOV2

} from "../actions/actionTypes";

const initalState = {
    isFetchingOS: false,
    periodoIni: (localStorage.getItem('v2periodoIni') !== null)? localStorage.getItem('v2periodoIni') : "1",
    periodoFim: (localStorage.getItem('v2periodoFim') !== null)? localStorage.getItem('v2periodoFim') : "2",
    ultimaAtualizacao: localStorage.getItem('v2ultimaAtualizacao') | new Date().toISOString(),
    os: JSON.parse(localStorage.getItem('v2os')) | []

}



export default (state = initalState, action) => {
    switch(action.type) {
        case FETCH_V2_OS_MOVIMENTADAS_PERIODO_DETALHADOV2:
            return {
                ...state,
                isFetchingOS: true
                //     estacoesTrabalho: []
            }
        case RECEIVE_V2_OS_MOVIMENTADAS_PERIODO_DETALHADOV2:
          //  localStorage.setItem('v2os', JSON.stringify(action.payload.data.os));
            localStorage.setItem('v2periodoIni', action.payload.data.periodoIni);
            localStorage.setItem('v2periodoFim', action.payload.data.periodoFim);
            localStorage.setItem('v2ultimaAtualizacao', action.payload);

            return {
                ...state,
                isFetchingOS: false,
                os: action.payload.data.os,
                periodoIni: action.payload.data.periodoIni,
                periodoFim: action.payload.data.periodoFim,
                ultimaAtualizacao: new Date().toISOString() //TODO: ultimaAtualizacao deve ser a data hora do ultimo modifiedOn
            }
        default:
            return state;
    }
}
